module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-carousel-list', {
    attrs: {
      "data": _vm.items,
      "items-to-show": 2
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_c('div', {
          staticClass: "card"
        }, [_c('div', {
          staticClass: "card-image"
        }, [_c('figure', {
          staticClass: "image is-5by4"
        }, [_c('a', {
          on: {
            "click": function($event) {
              _vm.info(props.index)
            }
          }
        }, [_c('img', {
          attrs: {
            "src": props.list.image
          }
        })])]), _vm._v(" "), _c('b-tag', {
          staticStyle: {
            "position": "absolute",
            "top": "0"
          },
          attrs: {
            "type": "is-danger",
            "rounded": ""
          }
        }, [_c('b', [_vm._v("50%")])])], 1), _vm._v(" "), _c('div', {
          staticClass: "card-content"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('p', {
          staticClass: "title is-6"
        }, [_vm._v(_vm._s(props.list.title))]), _vm._v(" "), _c('p', {
          staticClass: "subtitle is-7"
        }, [_vm._v("@johnsmith")]), _vm._v(" "), _c('div', {
          staticClass: "field is-grouped"
        }, [(props.list.rating) ? _c('p', {
          staticClass: "control"
        }, [_c('b-rate', {
          attrs: {
            "value": props.list.rating,
            "show-score": "",
            "disabled": ""
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "control",
          staticStyle: {
            "margin-left": "auto"
          }
        }, [_c('button', {
          staticClass: "button is-small is-danger is-outlined"
        }, [_c('b-icon', {
          attrs: {
            "size": "is-small",
            "icon": "heart"
          }
        })], 1)])])])])])]
      }
    }]),
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2018c6dc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/carousel/examples/ExWithCard.vue
// module id = 999
// module chunks = 3 161